import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import type { ThemedStyledProps } from 'styled-components';
import type { ChipSize } from './Chip';
import { useChip } from './useChip';

export type ChipAddonProps = {
  className?: string;
  children: React.ReactNode;
};

export const ChipAddon = forwardRef<HTMLSpanElement, ChipAddonProps>(function ForwardedChipAddon(
  { className, children, ...rest }: ChipAddonProps,
  ref
) {
  const { size } = useChip();
  return (
    // @ts-expect-error [EN-7967] - TS2769 - No overload matches this call.
    <BaseChipAddon {...rest} className={className} size={size} ref={ref}>
      {children}
    </BaseChipAddon>
  );
});

type BaseChipAddonProps = {
  size: NonNullable<ChipSize>;
};

const BaseChipAddon = styled.span`
  cursor: pointer;
  display: inline-flex;
  align-items: center;

  ${
    // @ts-expect-error [EN-10263] - TS2769 - No overload matches this call.
    ({ size }: ThemedStyledProps<BaseChipAddonProps, never>) => {
      if (size !== 'xs')
        return css`
          margin-right: -0.6rem;
        `;
    }
  }

  ${({ size }: ThemedStyledProps<BaseChipAddonProps, never>) => {
    if (size === 'xs' || size === 'sm') {
      return css`
        padding-left: 0.6rem;
      `;
    }
    return css`
      padding-left: 0.8rem;
    `;
  }}

  * + * {
    margin-left: 0.4rem;
  }

  svg {
    font-size: inherit;
    width: 1em;
    height: 1em;
  }

  ${({ size }: ThemedStyledProps<BaseChipAddonProps, never>) => {
    if (size === 'sm' || size === 'xs') {
      return css`
        padding-left: 0.6rem;
      `;
    }
    return css`
      padding-left: 0.8rem;
    `;
  }}
`;
